'use strict';


export class AccordionBasic {
  constructor() {
    const $accordionItems = $(".paragraph--type--accordion-basic .field--name-field-items");
    const $accordionItem = $accordionItems.find(".field__item");
    $accordionItem.find(".field--name-field-body").hide();
    $accordionItem.each(function () {
      $(this).find(".field--name-field-header").append("<div class='arrow-button'></div>");
      if ($(this).hasClass("is-active")) {
        $(this).find(".field--name-field-body").show(250);
      }
    });
    $accordionItem.find(".field--name-field-header").click(function (e) {
      e.preventDefault();
      var that = $(this),
        parent = that.parent(".paragraph").parent(".field__item");
      if (!parent.hasClass("is-active")) {
        that.next().stop().slideDown(250);
        parent.addClass("is-active").siblings(".is-active").removeClass("is-active").find(".field--name-field-body").slideUp(250);
      } else {
        parent.removeClass("is-active").find(".field--name-field-body").slideUp(250);
      }
    });
  }
}
